<template>
    <div v-if="mostrar">
        <div v-if="comandaItems" id="prinCom" style="text-align: center; font-size: 14px;">
            <div class="ticket">
                <div class="text-center" style="text-align: center; font-size: 14px;">
                    <b-row>
                        <b-col>
                            <h4 style=" font-size: 20px;">Comanda Producción</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <template>
                                Cliente: <b>{{comandaItems.ordenPago.receptor.razonSocial}}</b>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <template>
                                Lugar:  <b>{{comandaItems.ordenPago.tag3}}</b>
                            </template>
                        </b-col>
                    </b-row>  
                    <b-row>
                        <b-col>
                            <template>
                                Fecha: <b>{{comandaItems.created_at | moment('D/M/Y')}}</b> - <b>{{comandaItems.created_at | moment('hh:mm:ss A')}}</b>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <template>
                                User: <b>{{comandaItems.ordenPago.adicional.username}}</b>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <template >
                                Observaciones: <b>{{comandaItems.ordenPago.observaciones}}</b>
                            </template>
                        </b-col>
                    </b-row>
                </div>
                <hr>
                <b-row>
                    <b-col>
                        <div style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                            <b>ART&Iacute;CULO</b>
                        </div>
                        <div class="text-right" style="text-align: right; font-size: 14px; float:rigth; display: inline-block; width: 50%;">
                            <b>SUBTOTAL</b>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-for="(item, index) in comandaItems.ordenPago.items" :key="index">
                    <b-col>
                        <div style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                            <span style="margin: 0;">
                                <div>
                                    {{item.cantidad}}. {{item.unidadMedidaCantidad}} {{item.descripcion}}
                                </div>
                            </span>             
                            <span style="margin-left:15px; font-size:12px; text-transform:lowercase;">
                                {{ item.observacionItem }}
                            </span>
                        </div>
                        <div style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                            <span>{{(item.cantidad * item.precioVentaUnitario).toFixed(2)}}</span>
                        </div>
                    </b-col>
                </b-row><br><br>
                <b-row>
                    <b-col cols="2"></b-col>
                        <b-col style="text-align:center;margin-top:20px">
                            <template>
                                TOTAL: <b>{{comandaItems.ordenPago.moneda.simbolo}} {{(comandaItems.ordenPago.totales.importeTotal).toFixed(2)}}</b>
                            </template>
                        </b-col>
                    <b-col cols="2"></b-col>
                </b-row>
                <b-row>
                    <b-col style="text-align:center">
                        <template>
                            <b style="font-size:12px">Ticket interno, No es un comprobante</b>
                        </template>
                    </b-col>
                </b-row>    
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'PrintComanda',
    props:['dataitem','printComand'],
    data() {
        return {
            comandaItems:{},   
            mostrar: false 
        }
    },
     watch: {
        printComand: function () {
            if(this.printComand == true){
                var printContents = document.getElementById("prinCom").innerHTML
                var myWindow = window.open("", "MsgWindow", "width=400,height=800")
                myWindow.document.body.style.fontSize='10px'
                myWindow.document.body.style.textAlign='center'
                myWindow.document.write(printContents)
                myWindow.print(printContents)
                myWindow.close()
            }
        }
    },
    mounted(){
      this.mostrarData()  
    },
    methods:{
        mostrarData(){
            this.comandaItems = this.dataitem;
            if(this.comandaItems !=''){
                this.mostrar = true
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.ticket{
        border: 1px solid #ccc;
        border-radius: 10px;
        padding: 10px;
        font-family: 'Six Caps', sans-serif;
    }
</style>